import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { path } from '~/utils/media';

const Link = styled.a`
  @media (max-width: 700px) {
    &:first-child {
      >.card {
        margin-left: 20px;
      }
    }
    &:last-child {
      >.card {
        margin-right: 20px;
      }
    }
  }
`;

const Card = styled.div`
  cursor: pointer;
  user-select: none;
  padding-bottom: 30px;
  display: inline-block !important;
  vertical-align: top !important;
  white-space: normal !important;
  width: 16.66%;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  @media (max-width: 700px) {
    width: 22%;
    padding-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
    margin-right: 10px;
  }
`;

const CardInfo = styled.div`
  width: 100%;
`;

const CardImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 135px;
  border-radius: 6px;
  filter: opacity(50%);
  ${props => props.active && 'filter: opacity(100%);'}
  ${props => props.fog && 'filter: opacity(30%);'}
`;

const HistoryThumbnailCard = (props) => (
  <Link onClick={props.onClick}>
    <Card>
      <CardInfo>
        <CardImage
          active={props.active}
          fog={props.fog}
          src={props.data.cover_image && path(props.data.cover_image, 'rectangle-400-300')}
          srcSet={props.data.cover_image && `${path(props.data.cover_image, 'rectangle-800-600')} 2x`}
          alt={props.data.name}
        />
      </CardInfo>
    </Card>
  </Link>
);

HistoryThumbnailCard.propTypes = {
  fog: PropTypes.bool,
  active: PropTypes.bool, // eslint-disable-line
  data: PropTypes.object,
  onClick: PropTypes.func,
};
HistoryThumbnailCard.defaultProps = {
  fog: false,
  active: false,
  data: {}
};

export default HistoryThumbnailCard;
